import Box from "components/common/Box";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import Divider from "components/common/Divider";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { makeStyles } from "@mui/styles";
import React from "react";
import { CircularProgress } from "@mui/material";

const DashboardTimeConsumed = (props) => {
  const classes = useStyles();
  const TimeConvert = props?.time?.result?.total_time;
  const AvgTime = props?.time?.result?.avg_time;

  function timeConvert(n) {
    const num = n;
    const hours = num / 60;
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.round(minutes);
    return rhours + " hour  " + rminutes + " min";
  }

  return (
    <>
      <Card sx={{ minHeight: "350px" }}>
        {props.isLoadingtimeconsumeddata ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "200px",
              height: "20vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <CardContent>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Text className={classes.graphheading}>TIME CONSUMED</Text>

              <Box>
                <Stack direction="row" spacing={2}>
                  <Text className={classes.dateheading}>
                    {props?.time?.result?.since}-{props?.time?.result?.to}
                  </Text>
                </Stack>
              </Box>
            </Stack>

            <Divider
              sx={{ marginTop: "25px", marginBottom: "15px" }}
              variant="middle"
            />

            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Box>
                <Stack direction="row">
                  <Text
                    style={{ width: "70px" }}
                    className={classes.totalheading}
                  >
                    Total Time :
                  </Text>
                  <Text className={classes.valueheading}>
                    {timeConvert(TimeConvert ? TimeConvert : "0")}
                  </Text>
                </Stack>
              </Box>

              <Box>
                <Stack direction="row">
                  <Text
                    style={{ width: "130px" }}
                    className={classes.totalheading}
                  >
                    Avg Time Consumed :
                  </Text>
                  <Text
                    style={{ width: "95px" }}
                    className={classes.valueheading}
                  >
                    {timeConvert(AvgTime ? AvgTime : "0")}
                  </Text>
                </Stack>
              </Box>
            </Stack>

            <HighchartsReact highcharts={Highcharts} options={props.options} />
          </CardContent>
        )}
      </Card>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  HighchartsFirst: {
    "& .highcharts-container": {
      width: "100% !important",
    },
    "& .highcharts-root": {
      width: "100% !important",
    },
  },
  customSelect: {
    height: "40px !important",
    margin: 0,
    "& .MuiListItemText-primary": { fontSize: "14px !important" },
  },
  breadcrumbs: {
    fontSize: "14px",
    marginBottom: "20px",
    marginTop: "10px",
  },

  graphheading: {
    fontSize: "15px",
    color: "#545454",
    letterSpacing: "0.09px",
    textTransform: "uppercase",
    font: "Nunito Sans",
    fontWeight: "bold",
  },

  dateheading: {
    fontSize: "14px",
    color: "#B4B4BE",
    font: "Nunito Sans",
  },

  totalheading: {
    fontSize: "12px",
    color: "#7E84A3",
    fontWeight: "600",
    font: "Nunito Sans",
    marginTop: "5px",
  },

  valueheading: {
    fontSize: "11px",
    color: "#545454",
    fontWeight: "600",
    font: "Nunito Sans",
    marginTop: "6.5px",
  },
}));

export default DashboardTimeConsumed;
